module.exports = __webpack_public_path__ + "img/student.d610c823.svg";